@if (queryData) {
  <panel>
    <h1>{{title}}</h1>
    <div class="row">
      <div class="col-6">
        <data-table>
          <data-row>
            <custom-input [label]="'query.name' | translate" [inputType]="inputTypeEnum.Text" [(value)]="query.name" [placeholder]="'query.name-placeholder' | translate" [required]="true" />
          </data-row>
          <data-row>
            <label>{{ 'query.query-type' | translate }}</label>
            @if (query.id && queryType) {
              <div>{{ 'enum.query-type.' + queryTypeEnum[queryType] | translate }}</div>
            }
            @if (!query.id) {
              <custom-select
                [selectList]="queryTypeList"
                [placeholder]="'query.query-type-placeholder' | translate"
                [required]="true"
                [(value)]="queryType"
              (valueChange)="loadProperties()"></custom-select>
            }
          </data-row>
        </data-table>
      </div>
      <div class="col-6">
        <data-table>
          <data-row>
            <custom-input [label]="'query.description' | translate" [inputType]="inputTypeEnum.Textarea" [(value)]="query.description" [placeholder]="'query.description-placeholder' | translate" />
          </data-row>
        </data-table>
      </div>
    </div>
    @if (queryProperties) {
      <div>
        <table class="filters">
          <tr>
            <th></th>
            <th>{{ 'query.column.property' | translate }}</th>
            <th>{{ 'query.column.operator' | translate }}</th>
            <th>{{ 'query.column.value' | translate }}</th>
          </tr>
          @for (filter of queryData.filters; track filter; let index = $index) {
            <tr>
              <td>@if (index > 0) {
                <span class="remove-filter" (click)="removeFilter(index)"></span>
              }</td>
              <td><custom-select [selectList]="queryPropertiesList" [placeholder]="'query.property-placeholder' | translate" [required]="true" [value]="filter.property?.name" (valueChange)="setFilterProperty(filter, $event)" /></td>
              <td><custom-select [selectList]="filter.operatorsList" [placeholder]="'query.operator-placeholder' | translate" [required]="true" [(value)]="filter.operator" /></td>
              <td><input class="custom-input" disabled="disabled" type="text" autocompleteOff [(ngModel)]="filter.value" /></td>
            </tr>
          }
        </table>
        <span class="add-filter" (click)="addFilter();">
          <span class="icon"></span>
          {{ 'query.add-filter' | translate }}
        </span>
      </div>
    }
    <submit-button (click)="saveQuery()" [label]="'query.save' | translate" />
    @if (queryData && queryData.filters.length > 0) {
      <div>
        <h1>{{ 'query.add-input' | translate }}</h1>
        @if (queryProperties) {
          <div>
            <table style="width:100%">
              <tr>
                <th>{{ 'query.column.property' | translate }}</th>
                <th>{{ 'query.column.operator' | translate }}</th>
                <th>{{ 'query.column.input' | translate }}</th>
              </tr>
              @for (filter of queryData.filters; track filter) {
                <tr>
                  <td>{{ filter.property?.name }}</td>
                  <td>{{ 'query.operator.' + operatorType[filter.operator] | translate }}</td>
                  <td>
                    @if (!isNullOperator(filter.operator)) {
                      <query-input
                        [propertyName]="filter.property?.name"
                        [queryProperties]="queryProperties"
                        [options]="getOptions(filter)"
                        [(value)]="filter.value">
                      </query-input>
                    }
                  </td>
                </tr>
              }
            </table>
          </div>
        }
        <submit-button #runQueryButton
          (click)="runQuery()"
          [label]="'query.run' | translate"
          [ignoreValidation]="true"
          [active]="canSearch()">
        </submit-button>
        @if (results) {
          <div class="panel-section">
            <h1>{{ 'query.result' | translate }}</h1>
            <list-view>
              <header>#</header>
              <header>{{ 'general.column.company-name' | translate }}</header>
              <header>{{ 'general.column.flow-title' | translate }}</header>
              @if (queryData.queryType == queryTypeEnum.TaskAction) {
                <header>{{ 'general.column.action-type' | translate }}</header>
              }
              @if (queryData.queryType == queryTypeEnum.Taskflow) {
                <header>{{ 'general.column.flow-status' | translate }}</header>
              }
              <row *listData="let result from results; let index = index" statusColor="color-grey-40" (action)="navigateToTaskflow(result)">
                <column>{{ index + 1 }}</column>
                <column>{{ result.companyName }}</column>
                <column>{{ result.taskflowTitle }}</column>
                @if (queryData.queryType == queryTypeEnum.TaskAction) {
                  <column>{{ 'enum.task-action-type.' + taskActionTypeEnum[result.type] | translate }}</column>
                }
                @if (queryData.queryType == queryTypeEnum.Taskflow) {
                  <column>{{ result.taskflowStatus }}</column>
                }
              </row>
            </list-view>
          </div>
        }
      </div>
    }
  </panel>
}
